export const campaignListAction = ({ list }) => ({
  type: 'nuxiba_campaignList',
  list
})